import { render, staticRenderFns } from "./SingleInput.vue?vue&type=template&id=8c899454&scoped=true"
import script from "./SingleInput.vue?vue&type=script&lang=ts"
export * from "./SingleInput.vue?vue&type=script&lang=ts"
import style0 from "./SingleInput.vue?vue&type=style&index=0&id=8c899454&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c899454",
  null
  
)

export default component.exports